var module = angular.module('octopusApp.infrastructure');
var showdown = require('showdown');

module.directive('markdown', function ($sanitize) {
    var converter = new showdown.Converter({
        tables: true,
        strikethrough: true
    });
    return {
        restrict: 'E',
        scope: {
            text: '='
        },
        link: function (scope, element) {

            var refresh = function () {
                if (scope.text) {
                    var html = $sanitize(converter.makeHtml(scope.text))
                        .replace(/&#10;/g, "\n")
                        // Ensure the bootstrap styling is applied - could use a showdown converter, but seems like overkill
                        .replace(/<table/g, '<table class="table table-bordered table-striped"');
                    element.html(html);
                } else {
                    element.html('');
                }
            };
            scope.$watch('text', function () {
                refresh();
            });

            refresh();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/markdown.js
// module id = 668
// module chunks = 1